import React from "react"
import Ample from "../components/ample"
import ChainPicker from "../components/chainpicker"
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {formatCurrency, formatPct, stableSort} from "../components/utils"
import {optionName} from "../data/options"
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CircularProgress from '@material-ui/core/CircularProgress';

export default class OptionPicker extends React.Component {

  state = {
    selected_ticker: "AMZN",strikes:[],searching:false,displayed_ticker:"",displayed_expiry:"",displayed_option_type:"",
    sort_column:'iv',sort_order:'asc',selected_strike:null
  }

  chainChanged = new_chain => {
    this.setState(
      {
        selected_ticker:new_chain.ticker,
        selected_expiry:new_chain.expiry,
        selected_option_type:new_chain.option_type
      }
    )
  }

  fetchChainStrikes(ticker,expiry,option_type) {
    const url = `https://api.harsip.com/options/${ticker}/chain?expiry=${expiry}&option_type=${option_type}`
    //console.log(url)
    
    return (fetch(url)
            .then(res => res.json())
            .catch(console.log))
  }

  canEnableSearch() {
    return (this.formValid() && !this.state.searching)
  }
  formValid() { 
    return (this.state.selected_ticker!=="" && this.state.selected_expiry!=="")
  }
  formSubmitted = event => {
    //grab the values of these at the moment the request was made (they could change while we're fetching - we want to display this info once we get the data back)
    const ticker=this.state.selected_ticker; 
    const expiry=this.state.selected_expiry; 
    const option_type=this.state.selected_option_type;

    this.setState({strikes:[],searching:true}, 
      ()=>this.fetchChainStrikes(ticker,expiry,option_type)
      .then((data)=>this.setState({
                              strikes: data['strikes'],
                              min_strike: data['min_strike'],
                              max_strike: data['max_strike'],
                              step: data['step'],
                              displayed_ticker:ticker,
                              displayed_expiry:expiry,
                              displayed_option_type:option_type,
                              searching:false
                              })
            )
    );
  }

  handleSortRequest(col) {
    if (this.state.sort_column===col) { //if we're already sorting by this column
      let new_sort_order = (this.state.sort_order==='asc')?'desc':'asc';
      this.setState({sort_order:new_sort_order})
    } else {
      this.setState({sort_column:col})
    }
  }
  selectStrike(strike) {
    this.setState({selected_strike:strike},()=> this.notifyOfStrikeSelected())
  }
  notifyOfStrikeSelected(strike) {  //pass this info up to container
    const packet = {
      strike:this.state.selected_strike,
      expiry:this.state.selected_expiry,
      min_strike:this.state.min_strike,
      max_strike:this.state.max_strike,
      step:this.state.step
    }
    if (this.props.onStrikeSelected) this.props.onStrikeSelected(packet) //pass it up to container
  }
  render() {
    //{\"strike\":4790.0,\"lastPrice\":0.15,\"lastTradeDate\":1612449000000,\"mark\":0.02,\"impliedVolatility\":1.4375028125},
    let strikeTable = <></>
    let chainDetail = <></>
    if (this.state.searching===true) strikeTable=<CircularProgress color="inherit" />

    else {
      if (this.state.strikes.length>0) {
        chainDetail= <h6 className="card-subtitle">{optionName(this.state.displayed_option_type)} Strikes for {this.state.displayed_ticker} on {this.state.displayed_expiry}</h6>
        strikeTable=<>
                <Table stickyHeader size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow key="head">
                      <TableCell  key="strike">
                      <TableSortLabel
                          active={this.state.sort_column==="strike"} // do some validation to decide where the icon will be displayed
                          direction={this.state.sort_order} // hardcoded for now
                          onClick={(e) => {this.handleSortRequest('strike')}}>
                          Strike
                        </TableSortLabel>
                        </TableCell>
                      <TableCell key="mark">
                        <TableSortLabel
                          active={this.state.sort_column==="mark"} // do some validation to decide where the icon will be displayed
                          direction={this.state.sort_order} // hardcoded for now
                          onClick={(e) => {this.handleSortRequest('mark')}}>
                        Mark
                        </TableSortLabel>
                      </TableCell>
                      <TableCell key="impliedVolatility">
                      <TableSortLabel
                          active={this.state.sort_column==="impliedVolatility"} // do some validation to decide where the icon will be displayed
                          direction={this.state.sort_order} // hardcoded for now
                          onClick={(e) => {this.handleSortRequest('impliedVolatility')}}>
                        IV
                        </TableSortLabel>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {stableSort(this.state.strikes,this.state.sort_order, this.state.sort_column ).map((strike) => {
                      if (strike.mark > 0.0 && strike.impliedVolatility > 0.0099) {
                        let is_selected = (this.state.selected_strike && (this.state.selected_strike.strike === strike.strike))
                        return (<TableRow key={strike.strike} selected={is_selected} onClick={() => this.selectStrike(strike)}>
                                <TableCell>{strike.strike}</TableCell>
                                <TableCell>{formatCurrency(strike.mark)}</TableCell>
                                <TableCell>{formatPct(strike.impliedVolatility*100,2)}</TableCell>
                              </TableRow>);
                      }
                      return <></>
                    }
                  )}
                  </TableBody>
                </Table>
                </>
      }
    }
    
    return (
      <div>
        <div className="row" >
          <div className="card" style={{width:"100%"}}>
            <div className="card-body">
              <h4 className="card-title" >Load from option chain</h4>
                <ChainPicker 
                  onChainChanged={this.chainChanged} 
                  defaultTicker={this.state.selected_ticker}
                />
          
                <button id="go" disabled={!this.canEnableSearch()} onClick={this.formSubmitted}  type="submit"  className="btn btn-rounded btn-default btn-outline">
                  <i className="fas fa-play-circle  m-r-5"></i>Show
                </button>
              </div>
            </div>
        </div>

        <div className="row" >
          <div className="card" style={{width:"100%",visibility:(this.state.searching===true || this.state.strikes.length>0)?'visible':'hidden'}}>
            <div className="card-body">
              {chainDetail}
              {strikeTable}
            </div>
          </div>
        </div>
    </div>
    )
  }
}